export default __webpack_public_path__ + "static/media/scary_xmas_logo.d4a75a4a.png";